import { createSelector } from '@reduxjs/toolkit';
import { lightTheme, darkTheme } from 'components/theme/theme';

export const selectTheme = state => state.app.theme;

export const selectType = createSelector(selectTheme, theme => theme.type);

export const selectThemeObject = createSelector(selectType, type =>
  type === 'light' ? lightTheme : darkTheme,
);
